import Vue from "vue";
import Router from "vue-router";

import routerMobile from "./routerMobile.js";
import tServerMobile from "./routerThreeServer";
import tServerMobileFaa from "./routerThreeServerFaa";
import routerWebViewAerial from "./routerWebViewAerial.js"
import routerWebViewCourseSquare from "./routerWebViewCourseSquare.js"
import routerWebViewForum from "./routerWebViewForum.js"
import { routerUAVFlyManagePC } from "./routerUAVFlyManage.js"

import { behaviorStart } from "@/util/behavior.js";
import { setTitle } from "@/util/thirdPartyAdapter/baiduPromotion.js";
import store from "../store/index.js";

Vue.use(Router);


const router = new Router({
  base: "/",
  mode: "history",

  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/index",
      component: () => import("../views/home.vue"),
      children: [
        {
          path: "/index",
          name: "index",
          component: () => import("../views/index"),
          meta: { name: "首页", nameEn: "index" }
        },
        {
          path: "/products/:no",
          name: "products",
          component: () => import("../views/products"),
          meta: { name: "商品分类",nameEn: "CATEGORY" }
        },
        {
          path: "/productInfo/:goodsNo",
          name: "productInfo",
          component: () => import("../views/productInfo"),
          meta: { name: "商品详情" ,nameEn:"Product Details"}
        },
        {
          // 购物车
          path: '/shoppingCar',
          name: 'shoppingCar',
          meta: { title: '我的购物车', keepAlive: false},
          component: () => import('../views/shoppingCar'),
        },
        {
          // 订单提交页
          path: '/submitOrders',
          name: 'submitOrders',
          component: () => import('../views/submitOrders'),
          meta: {title: '确认订单', keepAlive: false}
        },
        {
          // 支付
          path: '/payment',
          name: 'payment',
          component: () => import('../views/payment'),
          meta: {title: '订单支付'}
        },
        {
          path: "/aboutUS",
          name: "aboutUS",
          component: () => import("../views/aboutUS"),
          meta: { name: "关于我们",nameEn: "About us" }
        },
        {
          path: "/application",
          name: "application",
          component: () => import("../views/application"),
          meta: { name: "应用",nameEn: "Applications" }
        },
        {
          path: "/enterpriseNews",
          name: "enterpriseNews",
          component: () => import("../views/enterpriseNews"),
          meta: { name: "新闻资讯" ,nameEn: "News"}
        },
        {
          path: "/newConent/:comNo",
          name: "newConent",
          component: () => import("../views/enterpriseNews/newConent.vue"),
          meta: { name: "新闻详情",nameEn: "News detail" }
        },
        {
          path: "/bannerContent/:advNo",
          name: "bannerContent",
          component: () => import("../views/bannerContent"),
          meta: { name: "广告详情" ,nameEn: "Ad Details"}
        },
        {
          path: "/APIPost",
          name: "APIPost",
          component: () => import("../views/APIPost"),
          meta: { name: "接口测试", nameEn: "APIPost"}
        },
        {
          path: "/NoFlyZoneSet",
          name: "NoFlyZoneSet",
          component: () => import("../views/NoFlyZoneSet"),
          meta: { name: "禁飞区域设置", nameEn: "NoFlyZoneSet"}
        },
        {
          path: "/FlightTrack",
          name: "FlightTrack",
          component: () => import("../views/FlightTrack"),
          meta: { name: "飞行轨迹", nameEn: "FlightTrack"}
        },
        {
          path: "/UOMValidate",
          name: "UOMValidate",
          component: () => import("../views/UOMValidate"),
          meta: { name: "UON验证", nameEn: "UOMValidate"}
        },
        {
          // 用户中心
          path: '/userPersonal',
          name: 'userPersonal',
          component: () => import('../views/userPersonal/userPersonal.vue'),
          meta: {keepAlive: false},
          redirect: {name: 'myAccount'},
          children: [
            {
              // 账号信息
              path: '/myAccount',
              name: 'myAccount',
              component: () => import('../views/userPersonal/myAccount.vue'),
              meta: {title: '个人中心_用户中心', keepAlive: false}
            },
            {
              // 我的订单
              path: '/myOrders',
              name: 'myOrders',
              component: () => import('../views/myOrders/orders.vue'),
              meta: {title: '个人中心_我的订单', keepAlive: false}
            },
            {
              // 订单详情
              path: '/orderStep/:orderNo',
              name: 'orderStep',
              component: () => import('../views/myOrders/orderStep.vue'),
              meta: {title: '商城_订单详情', keepAlive: false}
            },
            {
              // 我的收藏
              path: '/myCollection',
              name: 'myCollection',
              component: () => import('../views/userPersonal/myCollection.vue'),
              meta: {title: '个人中心_我的收藏', keepAlive: true}
            },
            {
              // 个人资料
              path: '/userpersonalData',
              name: 'userpersonalData',
              component: () => import('../views/userPersonal/userpersonalData.vue'),
              meta: {title: '个人中心_个人资料', keepAlive: false}
            },
            {
              // 安全中心
              path: '/securityCenter',
              name: 'securityCenter',
              component: () => import('../views/userPersonal/securityCenter.vue'),
              meta: {title: '个人中心_安全中心', keepAlive: true}
            },
            {
              // 收货地址管理
              path: '/address',
              name: 'address',
              component: () => import('../views/userPersonal/address.vue'),
              meta: {title: '个人中心_收货地址', keepAlive: false}
            },
            {
              // 使用协议
              path: '/useAgreement',
              name: 'useAgreement',
              component: () => import('../views/userPersonal/useAgreement.vue'),
              meta: {title: '个人中心_使用协议', keepAlive: true}
            },

            {
              // 飞行记录
              path: '/flyRecords',
              name: 'flyRecords',
              component: () => import('../views/userPersonal/flyRecords.vue'),
              meta: {title: '个人中心_飞行记录', keepAlive: true}
            }
          ]
        },
      ]
    },
    {
      path: "/loginAndRegister",
      name: "loginAndRegister",
      component: () => import("../views/loginAndRegister"),
      meta: { name: "登录/注册", nameEn: "login/register" }
    },
    {
      path: "/userRegistrationAgreement",
      name: "userRegistrationAgreement",
      component: () => import("../views/userRegistrationAgreement"),
      meta: { name: "用户协议", nameEn: "userRegistrationAgreement" }
    },
    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: () => import("../views/privacyPolicy"),
      meta: { name: "隐私权政策", nameEn: "privacyPolicy" }
    },
    {
      path: "/handsIdentify",
      name: "handsIdentify",
      component: () => import("../views/handsIdentify"),
      meta: { name: "手势识别", nameEn: "handsIdentify" }
    },
    // 移动端的router路径
    routerMobile,
    tServerMobile,
    tServerMobileFaa,
    routerWebViewAerial,
    routerWebViewCourseSquare,
    routerWebViewForum,

    routerUAVFlyManagePC,
    // 移动端登录注册
    {
      path: "/mobile/loginAndRegister",
      name: "mobile_loginAndRegister",
      component: () => import("../viewsMobile/loginAndRegister"),
      meta: { name: "登录/注册", nameEn: "login/register" }
    },
  ]
});

router.beforeEach((to, from, next) => {
  try {
    behaviorStart(to, from);
    if(app){
      app.scrollTop = 0
    }
  } catch (err) {
    console.error(err);
  } finally {
    const langType = store.state.lang.langType
    if(langType == 'en' && to.meta){
      const pageTitle = to.meta.nameEn || to.meta.name
      const pageName = pageTitle
      setTitle(pageName);
    }else if (to.meta && to.meta.name) {
      const pageName = to.meta.name;
      setTitle(pageName);
    }
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js